(function () {
  document.querySelectorAll("[data-quantity]").forEach(function (wrap) {
    var input = wrap.querySelector("input[name='quantity']");
    var minus = wrap.querySelector("[data-qty-minus]");
    var plus = wrap.querySelector("[data-qty-plus]");
    if (!input) return;

    function setValue(next) {
      var value = parseInt(next, 10);
      if (!value || value < 1) value = 1;
      input.value = String(value);
    }

    if (minus) {
      minus.addEventListener("click", function () {
        setValue((parseInt(input.value, 10) || 1) - 1);
      });
    }
    if (plus) {
      plus.addEventListener("click", function () {
        setValue((parseInt(input.value, 10) || 1) + 1);
      });
    }
  });

  var variantSelect = document.querySelector("[data-variant-select]");
  var price = document.querySelector("[data-product-price]");
  if (variantSelect && price) {
    variantSelect.addEventListener("change", function () {
      var option = variantSelect.options[variantSelect.selectedIndex];
      if (!option) return;
      var nextPrice = option.getAttribute("data-price");
      if (nextPrice) price.textContent = nextPrice;
    });
  }

  document.querySelectorAll("[data-product-gallery]").forEach(initProductGallery);
  initCartLiveUpdate();
  initCartModal();
})();

function initProductGallery(gallery) {
  var data = gallery.querySelector("[data-gallery-items]");
  var opener = gallery.querySelector("[data-gallery-open]");
  var lightbox = gallery.querySelector("[data-lightbox]");
  if (!data || !opener || !lightbox) return;

  var items = [];
  try {
    items = JSON.parse(data.textContent);
  } catch (error) {
    return;
  }
  if (!items.length) return;

  var mainImage = opener.querySelector("img");
  var stage = lightbox.querySelector("[data-lightbox-stage]");
  var zoomImage = stage.querySelector("img");
  var count = lightbox.querySelector("[data-lightbox-count]");
  var closeButton = lightbox.querySelector("[data-lightbox-close]");
  var index = 0;
  var scale = 1;
  var tx = 0;
  var ty = 0;
  var pointers = new Map();
  var drag = null;
  var pinch = null;
  var lastTap = 0;
  var ignoreClick = false;
  var lastPointerType = "mouse";
  var previousFocus = null;

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function applyTransform() {
    zoomImage.style.transform = "translate(" + tx + "px, " + ty + "px) scale(" + scale + ")";
  }

  function clampPan() {
    if (scale <= 1) {
      scale = 1;
      tx = 0;
      ty = 0;
      return;
    }
    var maxX = Math.max(0, (zoomImage.offsetWidth * scale - stage.clientWidth) / 2);
    var maxY = Math.max(0, (zoomImage.offsetHeight * scale - stage.clientHeight) / 2);
    tx = clamp(tx, -maxX, maxX);
    ty = clamp(ty, -maxY, maxY);
  }

  function stagePoint(clientX, clientY) {
    var rect = stage.getBoundingClientRect();
    return { x: clientX - (rect.left + rect.width / 2), y: clientY - (rect.top + rect.height / 2) };
  }

  function zoomToward(nextScale, clientX, clientY) {
    var next = clamp(nextScale, 1, 4);
    var point = stagePoint(clientX, clientY);
    var ratio = next / scale;
    tx = point.x - (point.x - tx) * ratio;
    ty = point.y - (point.y - ty) * ratio;
    scale = next;
    clampPan();
    applyTransform();
  }

  function resetZoom() {
    scale = 1;
    tx = 0;
    ty = 0;
    applyTransform();
  }

  function select(next, scrollLightbox) {
    index = (next + items.length) % items.length;
    var item = items[index];
    if (mainImage) {
      mainImage.src = item.preview;
      mainImage.srcset = "";
      mainImage.alt = item.alt || "";
      opener.classList.toggle("is-sticker", index === 0);
    }
    gallery.querySelectorAll("[data-gallery-index]").forEach(function (thumb) {
      thumb.classList.toggle("is-active", Number(thumb.getAttribute("data-gallery-index")) === index);
    });
    if (!scrollLightbox) return;
    resetZoom();
    zoomImage.alt = item.alt || "";
    if (zoomImage.getAttribute("src") !== item.src) zoomImage.src = item.src;
    if (count) count.textContent = index + 1 + " / " + items.length;
  }

  function openLightbox() {
    previousFocus = document.activeElement;
    lightbox.hidden = false;
    document.documentElement.style.overflow = "hidden";
    select(index, true);
    if (zoomImage.getAttribute("src") !== items[index].src) zoomImage.src = items[index].src;
    closeButton.focus();
  }

  function closeLightbox() {
    lightbox.hidden = true;
    document.documentElement.style.overflow = "";
    resetZoom();
    if (previousFocus && previousFocus.focus) previousFocus.focus();
  }

  gallery.querySelectorAll("[data-gallery-index]").forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      select(Number(thumb.getAttribute("data-gallery-index")), false);
    });
  });

  opener.addEventListener("click", openLightbox);
  lightbox.querySelectorAll("[data-lightbox-close]").forEach(function (button) {
    button.addEventListener("click", closeLightbox);
  });
  var prev = lightbox.querySelector("[data-lightbox-prev]");
  var next = lightbox.querySelector("[data-lightbox-next]");
  if (prev) prev.addEventListener("click", function () { select(index - 1, true); });
  if (next) next.addEventListener("click", function () { select(index + 1, true); });

  document.addEventListener("keydown", function (event) {
    if (lightbox.hidden) return;
    if (event.key === "Escape") closeLightbox();
    if (event.key === "ArrowLeft") select(index - 1, true);
    if (event.key === "ArrowRight") select(index + 1, true);
  });

  stage.addEventListener("pointerdown", function (event) {
    if (event.target.closest("[data-lightbox-close], [data-lightbox-prev], [data-lightbox-next]")) return;
    lastPointerType = event.pointerType || "mouse";
    try { stage.setPointerCapture(event.pointerId); } catch (error) {}
    pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    if (pointers.size === 2) {
      var pair = Array.from(pointers.values());
      drag = null;
      pinch = {
        dist: Math.hypot(pair[0].x - pair[1].x, pair[0].y - pair[1].y) || 1,
        scale: scale,
        cx: (pair[0].x + pair[1].x) / 2,
        cy: (pair[0].y + pair[1].y) / 2,
        tx: tx,
        ty: ty
      };
      return;
    }
    drag = { x: event.clientX, y: event.clientY, tx: tx, ty: ty, moved: false, type: event.pointerType };
  });

  stage.addEventListener("pointermove", function (event) {
    if (!pointers.has(event.pointerId)) return;
    pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    if (pointers.size >= 2 && pinch) {
      var pair = Array.from(pointers.values());
      var dist = Math.hypot(pair[0].x - pair[1].x, pair[0].y - pair[1].y) || 1;
      var midX = (pair[0].x + pair[1].x) / 2;
      var midY = (pair[0].y + pair[1].y) / 2;
      var next = clamp(pinch.scale * (dist / pinch.dist), 1, 4);
      var point = stagePoint(pinch.cx, pinch.cy);
      var ratio = next / pinch.scale;
      tx = point.x - (point.x - pinch.tx) * ratio + (midX - pinch.cx);
      ty = point.y - (point.y - pinch.ty) * ratio + (midY - pinch.cy);
      scale = next;
      clampPan();
      applyTransform();
      ignoreClick = true;
      return;
    }
    if (!drag) return;
    var dx = event.clientX - drag.x;
    var dy = event.clientY - drag.y;
    if (Math.abs(dx) + Math.abs(dy) > 8) drag.moved = true;
    if (scale > 1) {
      tx = drag.tx + dx;
      ty = drag.ty + dy;
      clampPan();
      applyTransform();
    }
  });

  function endPointer(event) {
    pointers.delete(event.pointerId);
    if (pointers.size < 2) pinch = null;
    if (pointers.size === 1 && scale > 1) {
      var remaining = Array.from(pointers.entries())[0];
      drag = { x: remaining[1].x, y: remaining[1].y, tx: tx, ty: ty, moved: true, type: "touch" };
      return;
    }
    if (pointers.size > 0) return;
    var gesture = drag;
    drag = null;
    if (!gesture) return;
    if (gesture.moved && scale === 1) {
      var dx = event.clientX - gesture.x;
      var dy = event.clientY - gesture.y;
      if (items.length > 1 && Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.2) {
        select(index + (dx < 0 ? 1 : -1), true);
        ignoreClick = true;
        return;
      }
    }
    if (!gesture.moved && gesture.type === "touch") {
      var now = Date.now();
      if (now - lastTap < 300) {
        lastTap = 0;
        ignoreClick = true;
        if (scale > 1) resetZoom();
        else zoomToward(2.5, event.clientX, event.clientY);
        return;
      }
      lastTap = now;
    }
    if (gesture.moved) ignoreClick = true;
  }

  stage.addEventListener("pointerup", endPointer);
  stage.addEventListener("pointercancel", endPointer);

  stage.addEventListener("click", function (event) {
    if (ignoreClick) {
      ignoreClick = false;
      return;
    }
    if (event.target === stage) closeLightbox();
  });

  stage.addEventListener("dblclick", function (event) {
    if (lastPointerType === "touch") return;
    if (event.target !== zoomImage) return;
    if (scale > 1) resetZoom();
    else zoomToward(2.5, event.clientX, event.clientY);
  });

  stage.addEventListener("wheel", function (event) {
    if (lightbox.hidden) return;
    event.preventDefault();
    zoomToward(scale * (event.deltaY < 0 ? 1.12 : 0.89), event.clientX, event.clientY);
  }, { passive: false });

  zoomImage.addEventListener("load", function () {
    clampPan();
    applyTransform();
  });
}

function initCartLiveUpdate() {
  var form = document.querySelector(".cart-form");
  if (!form) return;
  var inputs = form.querySelectorAll(".cart-qty");
  if (!inputs.length) return;

  var modal = document.querySelector("[data-cart-modal]");
  var root = modal ? modal.getAttribute("data-root") || "/" : "/";
  if (root.slice(-1) !== "/") root += "/";

  var timer = null;
  var sending = false;

  function readQty(input) {
    if (String(input.value).trim() === "") return null;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) return null;
    return qty;
  }

  function pendingUpdates() {
    var updates = {};
    var changed = false;
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var match = input.name.match(/^updates\[(.+)\]$/);
      var qty = readQty(input);
      if (!match || qty === null) return null;
      var previous = parseInt(input.getAttribute("data-qty"), 10);
      if (qty !== previous) changed = true;
      updates[match[1]] = qty;
    }
    return changed ? updates : null;
  }

  function push() {
    var updates = pendingUpdates();
    if (!updates || sending) return;
    sending = true;
    form.closest(".cart-page").classList.add("is-updating");
    fetch(root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (!response.ok) throw new Error("cart");
      window.location.reload();
    }).catch(function () {
      sending = false;
      form.closest(".cart-page").classList.remove("is-updating");
    });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(push, 400);
  }

  inputs.forEach(function (input) {
    input.addEventListener("input", schedule);
    input.addEventListener("change", schedule);
  });

  form.addEventListener("submit", function () {
    clearTimeout(timer);
  });

  form.querySelectorAll("a[href*='quantity=0']").forEach(function (link) {
    link.addEventListener("click", function () {
      clearTimeout(timer);
    });
  });
}

function initCartModal() {
  var modal = document.querySelector("[data-cart-modal]");
  if (!modal) return;

  var root = modal.getAttribute("data-root") || "/";
  if (root.slice(-1) !== "/") root += "/";
  var moneyFormat = (modal.getAttribute("data-money-format") || "€{{amount_with_comma_separator}}").replace(/<[^>]*>/g, "");
  var addLabel = modal.getAttribute("data-add-label") || "Add to cart";
  var errorLabel = modal.getAttribute("data-error") || "";
  var added = modal.querySelector("[data-cart-modal-added]");
  var error = modal.querySelector("[data-cart-modal-error]");
  var more = modal.querySelector("[data-cart-modal-more]");
  var grid = modal.querySelector("[data-cart-modal-grid]");
  var closeButton = modal.querySelector(".cart-modal__close");
  var title = document.getElementById("CartModalTitle");
  if (!added || !error || !more || !grid || !closeButton || !title) return;
  var titleDefault = title ? title.textContent : "";
  var previousFocus = null;
  var requestId = 0;
  var tones = ["mint", "peach", "lilac", "yellow"];

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function formatMoney(cents) {
    var value = (Number(cents) / 100).toFixed(2);
    var parts = value.split(".");
    var comma = parts[0] + "," + parts[1];
    return moneyFormat
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, comma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, parts[0])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/g, value);
  }

  function updateCount(count) {
    var link = document.querySelector("[data-cart-link]");
    var badge = link && link.querySelector("b");
    if (badge) badge.textContent = String(count);
    if (!link) return;
    var zero = link.getAttribute("data-cart-zero") || "";
    var one = link.getAttribute("data-cart-one") || "";
    var many = link.getAttribute("data-cart-many") || "";
    var label = count === 0 ? zero : count === 1 ? one : many.replace("2", String(count));
    if (label) link.setAttribute("aria-label", label);
  }

  function openModal() {
    previousFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.style.overflow = "hidden";
    if (closeButton) closeButton.focus();
  }

  function closeModal() {
    modal.hidden = true;
    document.documentElement.style.overflow = "";
    if (previousFocus && previousFocus.focus) previousFocus.focus();
  }

  function normalize(product) {
    var variants = product.variants || [];
    var variant = null;
    variants.forEach(function (item) {
      if (!variant && item.available) variant = item;
    });
    if (!variant) variant = variants[0];
    if (!variant) return null;
    var image = product.featured_image;
    if (image && image.src) image = image.src;
    if (!image && product.images && product.images[0]) image = product.images[0].src || product.images[0];
    return {
      id: product.id,
      title: product.title,
      url: product.url,
      price: variant.price,
      variantId: variant.id,
      available: Boolean(product.available && variant.available),
      image: image || ""
    };
  }

  function filterProducts(list, inCart) {
    var picked = [];
    (list || []).forEach(function (product) {
      var item = normalize(product);
      if (!item || !item.available || inCart[item.id]) return;
      if (picked.some(function (existing) { return existing.id === item.id; })) return;
      picked.push(item);
    });
    return picked;
  }

  function loadSuggestions(productId, cart) {
    var inCart = {};
    (cart.items || []).forEach(function (item) { inCart[item.product_id] = true; });
    return fetch(root + "recommendations/products.json?product_id=" + encodeURIComponent(productId) + "&limit=8&intent=related")
      .then(function (response) { return response.ok ? response.json() : { products: [] }; })
      .catch(function () { return { products: [] }; })
      .then(function (data) {
        var picked = filterProducts(data.products, inCart);
        if (picked.length >= 4) return picked.slice(0, 4);
        return fetch(root + "collections/all/products.json?limit=12")
          .then(function (response) { return response.ok ? response.json() : { products: [] }; })
          .catch(function () { return { products: [] }; })
          .then(function (extra) {
            filterProducts(extra.products, inCart).forEach(function (product) {
              if (picked.length >= 4) return;
              if (!picked.some(function (existing) { return existing.id === product.id; })) picked.push(product);
            });
            return picked.slice(0, 4);
          });
      });
  }

  function renderAdded(item) {
    var title = item.product_title || item.title || "";
    var variant = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
    var image = item.image
      ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(title) + '">'
      : "<span></span>";
    added.innerHTML = image + "<div><strong>" + escapeHtml(title) + "</strong>" +
      (variant ? "<small>" + escapeHtml(variant) + "</small>" : "") +
      "<b>" + escapeHtml(formatMoney(item.final_price || item.price)) + "</b></div>";
  }

  function renderSuggestions(products) {
    if (!products.length) {
      more.hidden = true;
      grid.innerHTML = "";
      return;
    }
    more.hidden = false;
    grid.innerHTML = products.map(function (product, index) {
      var tone = tones[index % tones.length];
      var image = product.image
        ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '">'
        : "<span></span>";
      return '<article class="cart-modal__card cart-modal__card--' + tone + '">' +
        '<a href="' + escapeHtml(product.url) + '">' + image +
        '<p class="product-name">' + escapeHtml(product.title) + "</p>" +
        '<p class="product-price">' + escapeHtml(formatMoney(product.price)) + "</p></a>" +
        '<button type="button" class="button button--secondary" data-modal-add data-variant-id="' + escapeHtml(product.variantId) + '" data-product-id="' + escapeHtml(product.id) + '">' +
        escapeHtml(addLabel) + " <span aria-hidden=\"true\">+</span></button></article>";
    }).join("");
  }

  function showCart(item) {
    var current = ++requestId;
    if (title) title.textContent = titleDefault;
    error.hidden = true;
    renderAdded(item);
    more.hidden = true;
    grid.innerHTML = "";
    openModal();
    return fetch(root + "cart.js", { headers: { Accept: "application/json" } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (current !== requestId) return;
        updateCount(cart.item_count);
        return loadSuggestions(item.product_id, cart);
      })
      .then(function (products) {
        if (current !== requestId || !products) return;
        renderSuggestions(products);
      })
      .catch(function () {});
  }

  function postAdd(body, button) {
    if (button) button.disabled = true;
    return fetch(root + "cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json", "Content-Type": "application/json" },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok) throw new Error(payload.description || payload.message || errorLabel);
        return payload;
      });
    }).then(function (item) {
      return showCart(item);
    }).catch(function (reason) {
      var message = reason instanceof Error && reason.message ? reason.message : errorLabel;
      if (title) title.textContent = message;
      error.hidden = true;
      added.innerHTML = "";
      more.hidden = true;
      openModal();
    }).finally(function () {
      if (button) button.disabled = false;
    });
  }

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches("form[action*='/cart/add']")) return;
    event.preventDefault();
    var data = new FormData(form);
    var id = data.get("id");
    if (!id) return;
    var quantity = parseInt(data.get("quantity"), 10);
    if (!quantity || quantity < 1) quantity = 1;
    postAdd({ id: Number(id), quantity: quantity }, form.querySelector("[type='submit']"));
  });

  grid.addEventListener("click", function (event) {
    var button = event.target.closest("[data-modal-add]");
    if (!button) return;
    postAdd({
      id: Number(button.getAttribute("data-variant-id")),
      quantity: 1
    }, button);
  });

  modal.querySelectorAll("[data-cart-modal-close]").forEach(function (button) {
    button.addEventListener("click", closeModal);
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && !modal.hidden) closeModal();
  });
}
